import { render, staticRenderFns } from "./soil.vue?vue&type=template&id=4b1bb09e&scoped=true&"
import script from "./soil.vue?vue&type=script&lang=js&"
export * from "./soil.vue?vue&type=script&lang=js&"
import style0 from "./soil.vue?vue&type=style&index=0&id=4b1bb09e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1bb09e",
  null
  
)

export default component.exports